import React from 'react';

import styles from './index.less';

function Error () {
  return (
    <div className={styles.errorWrap}>

      <div className={styles.errorContentWrap}>
        <div className={styles.errorImg} />
        <div className={styles.errorText}>抢购太火爆啦，请稍后再试下哦~</div>
      </div>

    </div>
  );
}

export default Error;